import * as React from 'react';
export function CityTabs(_a) {
    var cities = _a.cities, value = _a.value, onChange = _a.onChange;
    function buildClass(city) {
        return ['agenda-tabs-item', city.slug === value ? 'active' : ''].filter(Boolean).join(' ');
    }
    return (React.createElement("div", { className: "agenda-tabs" }, cities.map(function (city) { return (React.createElement("div", { key: city.slug, className: buildClass(city), onClick: function () { return onChange(city.slug); } }, city.name)); })));
}
